import { render, staticRenderFns } from "./A_Account.vue?vue&type=template&id=77993d2a&"
import script from "./A_Account.vue?vue&type=script&lang=js&"
export * from "./A_Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports